export default "__VITE_ASSET__BoNXImT___"